import { render } from "./AdminUserGames.vue?vue&type=template&id=f0bbfee4&scoped=true"
import script from "./AdminUserGames.vue?vue&type=script&lang=js"
export * from "./AdminUserGames.vue?vue&type=script&lang=js"

import "./AdminUserGames.vue?vue&type=style&index=0&id=f0bbfee4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0bbfee4"]])

export default __exports__